module.exports = __webpack_public_path__ + "img/400.dcdc40a4.svg";